import $ from 'jquery';
import EventBusService from '../services/EventBusService';
import { KEY_ESCAPE, PAUSED_VIDEO, STOP_VIDEO } from "../constans";
import VideoIframeService from "../services/VideoIframeService";

export default class PopupManager {
    private readonly OPEN_CLASS = 'open';
    private readonly FIXED_CLASS = 'fixed';
    private readonly SUCCESS_CLASS = 'success-state';

    private typePopup: string;

    private selectors = {
        popup: '.js-popup-template',
        popupWrapper: '.js-popup-wrapper',
        targetOpenPopup: '.js-open-popup',
        closePopup: '.js-close-popup',
        iframe: '.js-iframe-video',
    };

    constructor() {
        this.closeAllPopup = this.closeAllPopup.bind(this);
        this.open = this.open.bind(this);
        this.onEmptyAreaClick = this.onEmptyAreaClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.openPopupByType = this.openPopupByType.bind(this);

        this.init();
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void {
        $(document).on('click', this.selectors.targetOpenPopup, this.open);
        $(document).on('click', this.selectors.closePopup,this.closeAllPopup);

        document.addEventListener('keydown', (event: KeyboardEvent) => {
            this.handleKeyDown(event);
        });
    }

    /**
     * Открыть попап
     */
    public open(event: Event): void {
        const $target = $(event.currentTarget as HTMLElement);
        const typePopup = ($target.data('type-popup') as string) ?? null;

        if (!typePopup) {
            return;
        }

        this.typePopup = typePopup;

        const $activePopup = $(document).find(
            `.js-popup-template[data-popup=${typePopup}]`
        );

        this.closeAllPopup();
        $activePopup.addClass(this.OPEN_CLASS);

        $activePopup.on('mousedown', this.onEmptyAreaClick);
        $('html').addClass(this.FIXED_CLASS);
        EventBusService.triggerEvent(EventBusService.OPEN_POPUP, {
            type: this.typePopup,
        })
    }

    /**
     * Закрыть все попапы
     */
    public closeAllPopup(): void {
        const $popupContainer =  $(this.selectors.popup);
        EventBusService.triggerEvent(EventBusService.CLOSE_POPUP, {type: this.typePopup});
        $popupContainer.removeClass(this.OPEN_CLASS);

        //удаления секции успеха
        const $applicationSection = $popupContainer.find(
            '.js-application-section'
        );
        if ($applicationSection.length) {
            $applicationSection.removeClass(this.SUCCESS_CLASS);
        }

        $('html').removeClass(this.FIXED_CLASS);

        $popupContainer.find(this.selectors.iframe).each((_, iframe) => {
            if (!iframe) {
                return;
            }

            VideoIframeService.sendMessageToIframe(iframe as HTMLIFrameElement, PAUSED_VIDEO);
        })
    }

    /**
     * Обработчик клика на пустую область
     */
    public onEmptyAreaClick(event: Event): void {
        const $popupWrapper = $(event.target as HTMLElement).closest(
            this.selectors.popupWrapper
        );
        if (!$popupWrapper.get(0)) {
            this.closeAllPopup();
        }
    }

    /**
     * Функция обработчик нажатия кнопки клавиатуры
     * @param event
     */
    public handleKeyDown(event: KeyboardEvent): void {
        if (event.key === KEY_ESCAPE) {
            this.closeAllPopup();
        }
    }

    /**
     * Открыть попап по типу
     */
    public openPopupByType(typePopup: string, withFixed = true): JQuery {
        this.typePopup = typePopup;

        const $activePopup = $(document).find(
            `.js-popup-template[data-popup=${typePopup}]`);

        this.closeAllPopup();
        $activePopup.addClass(this.OPEN_CLASS);

        $activePopup.on('mousedown', this.onEmptyAreaClick);

        if (withFixed) {
            $('html').addClass(this.FIXED_CLASS);
        }

        return $activePopup;
    }
}
